import React from 'react';
import styled from 'styled-components';
import { AiFillCheckCircle, AiFillExclamationCircle } from 'react-icons/ai';
import { useHistory } from 'react-router-dom';

import { useScreenQuery, Button as ButtonCore } from 'playup-web-core';

import formatCurrency from '../../../../utils/formatCurrency';

const DepositSuccessfulMessage = ({ amount, messageType, close, isOnboarding }: DepositSuccessfulMessageProps) => {
	const { isSmall } = useScreenQuery();
	const history = useHistory();
	const onClose = () => {
		if (messageType) history.replace(`/${messageType}`);
		else close();
	};

	return (
		<DepositResultMessageContainer>
			<StyledAiFillCheckCircle size={75} color="green" />
			<ResultText isSmallScreen={isSmall}>Deposit Successful</ResultText>
			<ResultAmount>{formatCurrency(amount)}</ResultAmount>

			{isOnboarding && messageType === 'betting' && (
				<>
					<HintSection>
						<StyledHintIcon size={11} />
						<HintText>Open the Betslip to apply your bonus</HintText>
					</HintSection>
					<StyledButton kind={'playup'} onClick={onClose}>
						Start Betting
					</StyledButton>
				</>
			)}

			{isOnboarding && messageType === 'fantasy' && (
				<StyledButton kind={'fantasy'} onClick={onClose}>
					Start Playing
				</StyledButton>
			)}

			{!isOnboarding && (
				<StyledButton kind={messageType === 'betting' ? 'playup' : 'fantasy'} onClick={onClose}>
					Go Back
				</StyledButton>
			)}
		</DepositResultMessageContainer>
	);
};

export default DepositSuccessfulMessage;

interface DepositSuccessfulMessageProps {
	amount: number;
	close: () => void;
	isOnboarding?: boolean;
	messageType?: 'betting' | 'fantasy';
}

export const DepositResultMessageContainer = styled.div(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	color: theme.colors.darkR,
	background: theme.colors.white,
	zIndex: 20,
}));

const StyledAiFillCheckCircle = styled(AiFillCheckCircle)(({ theme }) => ({
	color: theme.colors.success,
	margin: '20px 0',
}));

export const ResultText = styled.p<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
	fontSize: '22px',
	fontWeight: 600,
	marginBottom: '10px',
}));

export const ResultAmount = styled.p(({ theme }) => ({
	fontSize: '20px',
	marginBottom: '15px',
}));

const HintSection = styled.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
});

const StyledHintIcon = styled(AiFillExclamationCircle)(({ theme }) => ({
	color: theme.colors.darkGreyRHighlight,
	marginRight: '5px',
}));

const HintText = styled.p(({ theme }) => ({
	fontSize: '11px',
	color: theme.colors.darkGreyRHighlight,
	margin: 0,
}));

export const StyledButton = styled(ButtonCore)({
	margin: '30px 0 10px',
	maxWidth: '326px',
});
